module.exports = __webpack_public_path__ + "img/headshot.2cc23779.jpg";